import { FC, useRef, useState } from 'react';
import { ContextMenuProps } from '@business/interfaces/context-menu';
import { SVGAssets } from '@business/assets/vectors';
import { useOutsideClickHandler } from '@utils/hooks/useOutsideClickHandler';
import { Button } from '../Button';

export const ContextMenu: FC<ContextMenuProps> = ({
  menuItems,
  isAlternateView = false,
  wrapperClass = '',
  itemContainerClass,
  iconClass = 'w-4 h-4',
  icon
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const menuRef = useRef(null);

  useOutsideClickHandler(menuRef, () => {
    setIsDropdownOpen(false);
  });

  return (
    <div ref={menuRef}>
      {isAlternateView ? (
        <div />
      ) : (
        <div
          data-testid="context-menu"
          className={`absolute right-1.5 -top-0.5 ${wrapperClass ?? 'z-30'}`}>
          <div className="dropdown context-menu-wrapper mb-2">
            <Button
              btnStyle="link"
              className={`inline-flex cursor-pointer three-dots-menu ${
                isDropdownOpen ? 'DropdownOpen' : ''
              }`}
              onClick={e => {
                e.stopPropagation();
                setIsDropdownOpen(prev => !prev);
              }}>
              {icon ?? (
                <SVGAssets.ThreeDots
                  className={iconClass}
                  data-testid="three-dots-icon"
                />
              )}
            </Button>
            {isDropdownOpen && (
              <ul
                data-testid="dropdown-content"
                style={{ maxHeight: 'none', overflow: 'visible' }}
                className={`shadow-lg bg-white dropdown-content rounded-md pb-1 mb-0 ${
                  itemContainerClass ?? ''
                }`}>
                {menuItems.map(row => {
                  return (
                    row && (
                      <Button
                        btnStyle="link"
                        data-testid={`menu-item-${row?.id}`}
                        key={row?.id}
                        className="!flex justify-between items-center w-full !text-left"
                        onClick={e => {
                          e.stopPropagation();
                          row?.onClick();
                          setIsDropdownOpen(false);
                        }}>
                        {row?.href ? (
                          <Button
                            btnStyle="link"
                            href={row?.href}
                            data-testid="menu-item-button"
                          />
                        ) : (
                          row?.label
                        )}
                      </Button>
                    )
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
